import { render, staticRenderFns } from "./InputType.vue?vue&type=template&id=06b23e7c&"
import script from "./InputType.vue?vue&type=script&lang=js&"
export * from "./InputType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports